import React, { FC, ReactNode } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

interface DashboardSectionAccordionProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
}

const DashboardSectionAccordion: FC<DashboardSectionAccordionProps> = ({
  title,
  children,
  defaultExpanded = false
}) => {
  const { t } = useKivunovaTranslation();
  const expandAria = t("dashboard-accordion-expand-section", "Expand section");
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "none",
        "&:before": { display: "none" },
        "&.Mui-expanded": { margin: 0, my: 0 },
        "& .MuiAccordionSummary-root": {
          minHeight: 56
        },
        "& .MuiAccordionSummary-content": {
          my: 1.5
        }
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{ color: "text.secondary", fontSize: 20 }}
            aria-label={expandAria}
          />
        }
        sx={{
          px: 3,
          py: 0,
          bgcolor: "background.paper",
          "&.Mui-expanded": {
            borderBottom: "1px solid",
            borderColor: "divider"
          }
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 3, py: 3 }}>
        <Box sx={{ width: "100%" }}>{children}</Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default DashboardSectionAccordion;
